/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ taxes: NonNullable<unknown> }} Admin_Shared_Plus_TaxInputs */

const en_admin_shared_plus_tax = /** @type {(inputs: Admin_Shared_Plus_TaxInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`plus ${i?.taxes}`)
};

const nl_admin_shared_plus_tax = /** @type {(inputs: Admin_Shared_Plus_TaxInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`plus ${i?.taxes}`)
};

/** @type {(inputs: Admin_Shared_Plus_TaxInputs) => LocalizedString} */
const de_admin_shared_plus_tax = en_admin_shared_plus_tax;

/** @type {(inputs: Admin_Shared_Plus_TaxInputs) => LocalizedString} */
const es_admin_shared_plus_tax = en_admin_shared_plus_tax;

/** @type {(inputs: Admin_Shared_Plus_TaxInputs) => LocalizedString} */
const fr_admin_shared_plus_tax = en_admin_shared_plus_tax;

/** @type {(inputs: Admin_Shared_Plus_TaxInputs) => LocalizedString} */
const it_admin_shared_plus_tax = en_admin_shared_plus_tax;

/** @type {(inputs: Admin_Shared_Plus_TaxInputs) => LocalizedString} */
const pt_br2_admin_shared_plus_tax = en_admin_shared_plus_tax;

/** @type {(inputs: Admin_Shared_Plus_TaxInputs) => LocalizedString} */
const pl_admin_shared_plus_tax = en_admin_shared_plus_tax;

/** @type {(inputs: Admin_Shared_Plus_TaxInputs) => LocalizedString} */
const hu_admin_shared_plus_tax = en_admin_shared_plus_tax;

/** @type {(inputs: Admin_Shared_Plus_TaxInputs) => LocalizedString} */
const ro_admin_shared_plus_tax = en_admin_shared_plus_tax;

/**
* | output |
* | --- |
* | "plus {taxes}" |
*
* @param {Admin_Shared_Plus_TaxInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_shared_plus_tax = /** @type {((inputs: Admin_Shared_Plus_TaxInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Shared_Plus_TaxInputs, { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_shared_plus_tax(inputs)
	if (locale === "de") return de_admin_shared_plus_tax(inputs)
	if (locale === "es") return es_admin_shared_plus_tax(inputs)
	if (locale === "fr") return fr_admin_shared_plus_tax(inputs)
	if (locale === "nl") return nl_admin_shared_plus_tax(inputs)
	if (locale === "it") return it_admin_shared_plus_tax(inputs)
	if (locale === "pt-BR") return pt_br2_admin_shared_plus_tax(inputs)
	if (locale === "pl") return pl_admin_shared_plus_tax(inputs)
	if (locale === "hu") return hu_admin_shared_plus_tax(inputs)
	return ro_admin_shared_plus_tax(inputs)
});
export { admin_shared_plus_tax as "admin.shared.plus_tax" }